import React, {  useState }  from 'react';
import ChooseActionTamplate from '../actionTamplate/ChooseActionTamplate';
import CustomSliderRange from '../sliders/CustomSliderRange';
import TipsTamplate from '../TipsTamplate';
import CustomSliderRange25 from '../sliders/CustomSliderRange25';
import {statusActionsAdvanced} from '../../../constants/common'
import './flagCustomisation.scss'

const FlagCustomisationItem = ({item, data}) => {
    const [currentAction, setCurrentAction] = useState(data && data[item.keyName] ? data[item.keyName] : 'Kick')

    return (
        <div className='flag_customisation_item_wrap'>
            <h4>{item.title}</h4>
            <div className='white_list_block_item_title_block flag_customisation_item_wrap_title'>
            <p className=''>Sensitivity</p>
            <TipsTamplate
                title={item.tipsTitle}
                label={item.label}
                text={item.text}
                textSecond={item.textSecond}
                />
            </div>
            {item.title === 'Z̴̞͝a̵̞̐l̴̘̏g̵̘̈́o̴̻͆  Text' ?
            <CustomSliderRange25
                currentAction={currentAction}
                setCurrentAction={setCurrentAction}
                item={statusActionsAdvanced}
                keyName={item.sliderKeyName}
                data={data}
                advance
            />
            :
            <CustomSliderRange
                currentAction={currentAction}
                setCurrentAction={setCurrentAction}
                item={statusActionsAdvanced}
                keyName={item.sliderKeyName}
                data={{ data: data }}
                advance
            />
            }
            <p>Punishment</p>
            <ChooseActionTamplate
                keyName={item.keyName}
                currentAction={currentAction}
                setCurrentAction={setCurrentAction}
                actionArr={statusActionsAdvanced}
                advance
            />
        </div>
    );
};

export default FlagCustomisationItem;